/**
 * 呼び出し元画面の入力情報を格納するVO
 */
export class KYMW0C00InputModel {
  // 処理区分	1:新規モード、2:編集モード
  public ProcessDiv: number = <number>1;

  // ユーザＩＤ
  public UserID: string = <string>'';

  // 権限
  public funcPermission: string = <string>'';

  // 画像ID
  public ImageID: string = <string>'';

  // Pコード
  public pcode: string = <string>'';
}
